import { Injectable } from '@angular/core';
interface ICacheItem {
  key: string;
  value: string;
}
@Injectable({
  providedIn: 'root'
})
export class RdfCacheService {
  maxImageCacheSize = 100;
  imageCache:Array<ICacheItem> = [];
  constructor() { }

  addImage(key: string, image: string) {
    if (!image || !key) return
    const item = this.imageCache.find(t=>t.key === key);
    if (item) {
      item.value = image;
    }else {
      if (this.imageCache.length>=this.maxImageCacheSize) {
        this.imageCache = this.imageCache.splice(0,1);
      }
      this.imageCache.push({key: key, value: image});
    }
  }
  getImage(key: string):string {
    const item = this.imageCache.find(t=>t.key === key);
    if (item) {
      return item.value;
    } else {
      return undefined;
    }
  }
  clearImageCache(){
    this.imageCache = [];
  }
}
